/**
 * @prettier
 */

export const ADDRESS_CHECK_UUID_LIMIT_ID = "gdc_addresscheck_uuid_reached";

const ADDRESS_VERIFICATION_LIMIT_DETAIL = "address verification limit";

/**
 * True when verification returns HTTP 200 with a quota-exhausted body, e.g.
 * { id: "gdc_addresscheck_uuid_reached", code: 429, detail: "..." }
 */
export function isAddressVerificationQuotaResponse(response) {
    if (!response || typeof response !== "object") {
        return false;
    }

    if (response.id === ADDRESS_CHECK_UUID_LIMIT_ID) {
        return true;
    }

    return (
        Number(response.code) === 429 &&
        typeof response.detail === "string" &&
        response.detail
            .toLowerCase()
            .includes(ADDRESS_VERIFICATION_LIMIT_DETAIL)
    );
}

/**
 * True for quota responses on HTTP 200 bodies or rejected axios errors.
 */
export function isAddressVerificationLimitReached(payload) {
    if (!payload) {
        return false;
    }

    if (isAddressVerificationQuotaResponse(payload)) {
        return true;
    }

    const nested = payload.response?.data;
    if (isAddressVerificationQuotaResponse(nested)) {
        return true;
    }

    const status = Number(
        payload.status ?? payload.code ?? payload.response?.status
    );
    const errorId = payload.id ?? nested?.id;

    return status === 429 || errorId === ADDRESS_CHECK_UUID_LIMIT_ID;
}
